var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.canShow)?_c('a',{attrs:{"href":_vm.showLink,"target":"_blank"},on:{"click":function($event){$event.stopPropagation();}}},[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]):_c('span',[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }